module.exports = __webpack_public_path__ + "img/long-dark-monochrome.2f0a9b0.svg";